import React from 'react';
import MatchFormPage from './MatchFormPage';
const CreateMatchPage: React.FC = () => <MatchFormPage editing={false} />;
export default CreateMatchPage;
